var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExportBottomleft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 9,
  fill: "none",
  viewBox: "0 0 18 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "M17.826 8.578V7.5H1.585V.722H.336V8.6z"
})));
export { SvgExportBottomleft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE4IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNy44MjYyIDguNTc3NzJWNy40OTk5NUgxLjU4NVYwLjcyMjE2OEgwLjMzNjQyNlY4LjU5OTk1TDE3LjgyNjIgOC41Nzc3MloiIGZpbGw9IiMwMEEzMkUiLz4KPC9zdmc+Cg==";